import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import { connect } from 'react-redux';
import Button from 'react-bootstrap/lib/Button';
// import Iframe from "react-iframe";
import qs from 'query-string';
import NetTask from '../../../requests/tasks/net/netTask';
import { GetRegion } from '../../../constants';
import RequestManager from '../../../requests/RequestManager';
import NetWFTask from '../../../requests/tasks/net/netWFTask';
import * as actions from '../../../actions/response';
import { converter } from '../../../helpers/converter';
import PaywayConfirmTask from '../../../requests/tasks/PaywayConfirmTask';
import { withRouterListener } from '../../../utils/hocs/withRouterListener'

import NavUtils from '../../../utils/nav/Utils';
const classButtonInactive = 'btn btn-default close-modal ';

class ModalNetVendors extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.state = { frame: false };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.props.closeModal('NetVendors');
    const linkIn = `/${GetRegion()}/login`;
   this.props.history.navigate(linkIn);
  }

  UNSAFE_componentWillMount() {
    if (this.props.__forceShowFrame) {
      this.showIframe();
    }
  }

  openExternalNet() {
    localStorage.getItem('net_purchase_url')
      ? window.open(localStorage.getItem('net_purchase_url'))
      : window.open('http://servicos.netcombo.com.br');
  }

  confirmNetStart() {
    const customEndPoint = localStorage.getItem('loginInfo.netPurchaseURL');
    const netWFTask = new NetWFTask({ customEndPoint });
    RequestManager.addRequest(netWFTask)
      .then(result => {
        result.response.list.forEach(data => {
          if (data.gateway == 'netgate') {
            const url = data.buyLink;
            const pwTask = new PaywayConfirmTask(url);
            RequestManager.addRequest(pwTask)
              .then(result => {
                console.log('NET', result);
              })
              .catch(err => {
                const message =
                  this.props.translations.net_msj_error_sinsucripcion ||
                  err.message;
                const modalOptions = {
                  modalType: 'ErrorSimple',
                  props: {
                    message,
                    onAccept: modalScope => {
                      if (this.props.__forceConfirm) {
                        modalScope.closeModal();
                        return;
                      }
                      window.location.reload();
                    },
                  },
                };
                this.props.showModal(modalOptions);
              });
          }
        });
      })
      .catch(err => {
        this.setState({ waiting: false });
        const buttonMessage = converter.convertApaUnicode(
          this.props.translations,
          'registro_aceptar',
        );
        const message = converter.convertApaUnicode(
          this.props.translations,
          'bad_response_error_msg',
        );
        const modal = {
          modalType: 'ErrorSimple',
          props: {
            message,
            onAccept: () => {
              this.props.closeModal('ErrorSimple');
            },
          },
        };

        this.props.showModal(modal);
      });
  }

  closeModal() {
    this.props.closeModal('NetVendors');
  }

  showIframe(test, url) {
    if (test == 'default') return this.handleClick();
    if (url) window.purchase_url = url;

    const _this = this;
    window.MessageHandler = function(event) {
      switch (event) {
        case 'register':
          _this.closeModal();
          const modalOps = {
            modalType: 'SuccessSimple',
            props: {
              message: converter.convertApaUnicode(
                _this.props.translations,
                'net_success_ful_validation_msg',
                'Parabéns! Você já pode aproveitar mais de 20 mil conteúdos disponíveis no Claro video. Além disso, pode acessar em até 5 dispositivos usando o mesmo login e senha. Aproveite!',
              ),
              onAccept: () => {
                location.reload();
              },
              onClose: () => {
                location.reload();
              },
            },
          };
          _this.props.showModal(modalOps);
          break;
        default:
          window.location.reload();
      }
    };

    const netTask = new NetTask({
      region: GetRegion(),
      callback_fe: 'webcallback',
      socialnetwork: 'NET',
    });
    RequestManager.addRequest(netTask)
      .then(result => {
        const { redirectUrl } = result.response;
        const pdRctUrl = NavUtils.parseUrl(redirectUrl);
        const params = qs.parse(pdRctUrl.search);
        const pdCbUrl = NavUtils.parseUrl(params.redirect_uri); // Url callback
        const pdHtUrl = NavUtils.parseUrl(window.location.href); // Url local
        // Rewrite url to use the local url

        params.redirect_uri = `${pdCbUrl.protocol}//${pdCbUrl.hostname}${
          pdCbUrl.pathname
        }${pdCbUrl.search}${pdCbUrl.hash}`;
        params.redirect_uri = params.redirect_uri.replace(
          '.comnet',
          '.com/net',
        );
        const search = `?${qs.stringify(params)}`;

        let urlFrame = `${pdRctUrl.protocol}//${pdRctUrl.hostname}${
          pdRctUrl.pathname
        }${search}${pdRctUrl.hash}`;
        urlFrame = urlFrame.replace('.brauth', '.br/auth');

        this.setState({ frame: true, urlFrame });
      })
      .catch(err => {
        this.setState({ waiting: false });
        const buttonMessage = converter.convertApaUnicode(
          this.props.translations,
          'registro_aceptar',
        );
        const message = converter.convertApaUnicode(
          this.props.translations,
          'bad_response_error_msg',
        );
        const modalOptions = {
          visibility: true,
          message,
          modalType: 'ErrorSimple',
          title: '',
          button: [
            {
              active: true,
              message: buttonMessage,
              callback: scopeModal => {
                scopeModal.closeModal();
              },
            },
          ],
          positionButtons: 'flex-end',
        };
        this.props.showModal(modalOptions);
      });
  }

  render() {
    const netButtonsClass = `col-lg-12 col-md-12 col-sm-12 col-xs-12`;
    const pro = JSON.parse(this.props.metadata.login_providers);

    if (this.props.__forceConfirm) {
      return (
        <Modal show>
          <Modal.Header
            style={{
              'border-top-left-radius': '6px',
              'border-top-right-radius': '6px',
              borderBottomLeftRadius: '6px',
              borderTopRightRadius: '6px',
              'background-color': 'white',
              backgroundColor: 'white',
              color: 'black',
              'font-size': 'x-large ',
            }}
            className="text-center"
          >
            <Button
              className="close close-modal net-close"
              style={{
                color: 'black',
              }}
              onClick={this.closeModal}
            >
              x
            </Button>

            {converter.convertApaUnicode(
              this.props.translations,
              'net_nosusc_titulo',
              'No Identificamos tu Suscripcion',
            )}

            <h4 className="modal-title text-center">
              {converter.convertApaUnicode(
                this.props.translations,
                'net_nosusc_instrucciones',
                'Seleccciona una Opcion',
              )}
            </h4>
          </Modal.Header>
          <Modal.Body
            style={{
              height: '150px',
              padding: '30px 0px',
              'background-color': 'white',
            }}
          >
            <a
              className="btn btn-primary btn-lg btn-block padding-right-left-10"
              onClick={this.openExternalNet.bind(this)}
              style={{
                width: '80%',
                'top:': '50px',
                left: '10%',
                position: 'relative',
              }}
            >
              {converter.convertApaUnicode(
                this.props.translations,
                'net_nosusc_asociar',
                'Debes seleccionar un servicio de NET',
              )}
            </a>
            <a
              className="btn btn-primary btn-lg btn-block padding-right-left-10"
              onClick={this.confirmNetStart.bind(this)}
              style={{
                width: '80%',
                left: '10%',
                position: 'relative',
              }}
            >
              {converter.convertApaUnicode(
                this.props.translations,
                'net_nosusc_confirmacion',
                'Debes seleccionar un servicio de NET',
              )}
            </a>
          </Modal.Body>
        </Modal>
      );
    }
    if (this.state.frame || this.props.__forceShowFrame) {
      return (
        <Modal show>
          <Modal.Body
            style={{
              height: '400px',
              padding: '0px',
            }}
          >
            <iframe
              src={this.state.urlFrame}
              className="net-iframe"
              height="100%"
              width="100%"
              style={{
                'border-radius': '6px',
              }}
            />
            <Button
              className="close close-modal net-close"
              style={{
                right: '-5px',
                top: '-5px',
                position: 'absolute',
                'background-color': 'white',
                color: 'black',
                'border-radius': '9px',
                width: '20px',
                'text-align': 'center',
                'z-index': '5',
                'text-decoration': 'none',
              }}
              onClick={this.closeModal}
            >
              x
            </Button>
          </Modal.Body>
        </Modal>
      );
    }
    return (
      <Modal show>
        <Modal.Header
          style={{
            borderTopLeftRadius: '6px',
            borderTopRightRadius: '6px',
            backgroundColor: '#f4f4f4',
            color: 'black',
            fontSize: 'x-large ',
          }}
        >
          <Button
            className="close close-modal net-close"
            style={{
              color: 'black',
            }}
            onClick={this.closeModal}
          >
            x
          </Button>
          <h4 className="modal-title text-center">
            {converter.convertApaUnicode(
              this.props.translations,
              'login_net_title_label',
              '',
            )}
          </h4>
        </Modal.Header>
        <Modal.Body
          className="text-center success"
          style={{
            backgroundColor: '#f4f4f4',
          }}
        >
          <div className={netButtonsClass}>
            {pro.net.providers.map((item, index) => {
              if (index < pro.net.providers.length - 1)
                return (
                  <a
                    className=""
                    style={{
                      width: '28%',
                      marginLeft: '4%',
                      display: 'inline-block',
                      border: 'solid black 1px',
                    }}
                    onClick={() =>
                      this.showIframe(item.autenticationType, item.url)
                    }
                    key={index}
                  >
                    <img
                      style={{
                        width: '100%',
                      }}
                      src={this.props.asset[item.img]}
                    />{' '}
                  </a>
                );
            })}

            {/*       <Button
                className={ classButtonInactive }
                onClick={(e) => this.buttonModal(e, button.callback)}>
                NET
              </Button>
              <Button
                className={ classButtonInactive }
                onClick={(e) => this.buttonModal(e, button.callback)}>
                NET
              </Button> */}
          </div>
        </Modal.Body>
        <Modal.Footer
          style={{
            borderBottomLeftRadius: '6px',
            borderBottomRightRadius: '6px',
            backgroundColor: '#f4f4f4',
            color: 'black',
            fontSize: 'large ',
            paddingTop: '0px',
          }}
        >
          <div className="footer-modal-button">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 padding-top-05 text-center ">
              <p
                className="padding-2"
                dangerouslySetInnerHTML={{
                  __html: converter.convertApaUnicode(
                    this.props.translations,
                    'login_register_net_description_label',
                    '',
                  ),
                }}
              />
              <Button
                style={{
                  backgroundColor: 'gray',
                  color: 'white ',
                  padding: '12px 40px',
                }}
                className={classButtonInactive}
                onClick={this.handleClick}
              >
                {converter.convertApaUnicode(
                  this.props.translations,
                  'net_click_login',
                  'Ingresar',
                )}
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  translations: state.translations,
  asset: state.asset,
  metadata: state.metadata,
});

const mapDispatchToProps = dispatch => ({
  showModal(modal) {
    dispatch(actions.showModal(modal));
  },
  closeModal(modalType) {
    dispatch(actions.removeModal(modalType));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouterListener(ModalNetVendors));
